import React, { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import { FieldProps } from "react-jsonschema-form";
import MultiCheckboxGroup from "../../witadmin/CRUD/Common/MultiCheckBoxGroup";
import { WitLabel } from "../../shared/widgets/common";
import { AccommodationConfig } from "../infraestructure/campingMap.dto";
import { campingMapMessages } from "../messages";
import { useAccommodationsQuery } from "../../accommodation/accommodation.hook";

export default function AccommodationConfigWidget({
  schema,
  formData,
  onChange,
  idSchema,
}: FieldProps) {
  const intl = useIntl();
  const { data: accommodations = [] } = useAccommodationsQuery();

  const options = useMemo(
    () =>
      accommodations
        .filter(a => a.active)
        .map(a => ({
          ticker: a.ticker,
          name: a.translationsList?.[0]?.name || a.ticker,
        })),
    [accommodations]
  );

  const selectedTickers = Object.keys(formData || {}).filter(
    key => (formData as Record<string, AccommodationConfig>)[key]?.enabled
  );

  const handleOnChange = useCallback(
    ({ value }: { value: string[] }) => {
      const newConfig: Record<string, AccommodationConfig> = {};
      for (const ticker of value) {
        newConfig[ticker] = (formData as Record<string, AccommodationConfig>)?.[ticker] || {
          enabled: true,
        };
      }
      onChange(newConfig);
    },
    [onChange, formData]
  );

  return (
    <div id={idSchema.$id}>
      <WitLabel>{schema?.title}</WitLabel>
      <p>{intl.formatMessage(campingMapMessages.accommodationConfigHelpText)}</p>
      <MultiCheckboxGroup
        className="witadmin-bs3"
        value={selectedTickers}
        field={{
          fieldName: "accommodationConfig",
          options,
          selectables: true,
        }}
        onChange={handleOnChange}
      />
    </div>
  );
}
